// export const capital_tableHeader2 = [
//     "Pay In/ Pay Out (₹)",
//     "Total GST (₹)",
//     "Turn. Tax (₹)",
//     "Min. Brok. (₹)",
//     "Exch. Charges (₹)",
//     "Stamp Duty Charges (₹)",
//     "STT (₹)",
//     "Sebi Tax (₹)",
//     "IPF Charges (₹)",
//     "Net (₹)",
//   ];

export const capital_tableHeader2 = [
  {
    id: "pay_in_pay_out",
    Header: "Pay In/ Pay Out (₹)",
    accessorKey: "pay_in_pay_out",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "total_gst",
    Header: "Total GST (₹)",
    accessorKey: "total_gst",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "turn_tax",
    Header: "Turn. Tax (₹)",
    accessorKey: "turn_tax",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "min_brokerage",
    Header: "Min. Brok. (₹)",
    accessorKey: "min_brokerage",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "exchange_charges",
    Header: "Exch. Charges (₹)",
    accessorKey: "exchange_charges",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "stamp",
    Header: "Stamp Duty Charges (₹)",
    accessorKey: "stamp",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "stt",
    Header: "STT (₹)",
    accessorKey: "stt",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "sebi_tax",
    Header: "Sebi Tax (₹)",
    accessorKey: "sebi_tax",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "ipf_charges",
    Header: "IPF Charges (₹)",
    accessorKey: "ipf_charges",
    headerStyle: { letterSpacing: "0.5px" },
  },
  {
    id: "total_net",
    Header: "Net (₹)",
    accessorKey: "total_net",
    headerStyle: { letterSpacing: "0.5px" },
  },
];


 export const capital_columns = [
      {
        id: "instrument",
        Header: "INSTRUMENT",
        accessorKey: "instrument",
      },
      // { id: "exchange", Header: "Exchange", accessorKey: "exchange" },
      // { id: "segment", Header: "Segment", accessorKey: "segment" },
      // { id: "particulars", Header: "Particulars", accessorKey: "particulars" },
      {
        id: "buy_qty",
        Header: "Buy Qty.",
        accessorKey: "buy_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "buy_value",
        Header: "Buy Value (₹)",
        accessorKey: "buy_value",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_qty",
        Header: "Sell Qty.",
        accessorKey: "sell_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "sell_value",
        Header: "Sell Value (₹)",
        accessorKey: "sell_value",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "net_qty",
        Header: "Net Qty.",
        accessorKey: "net_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "net_value",
        Header: "Net Value (₹)",
        accessorKey: "net_value",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "avg_rate",
        Header: "Avg. Rate (₹)",
        accessorKey: "avg_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "closing_price",
        Header: "Closing Price (₹)",
        accessorKey: "closing_price",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },

      {
        id: "pnl",
        Header: "Profit/Loss (₹)",
        accessorKey: "pnl",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          const value = parseFloat(row?.getValue());
          const formattedValue = value
            ? value.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0.00";
          return (
            <>
            {value > 0 ? (
              <span className="text-success mb-0">
                {formattedValue}
                {/* <i className="ms-1 ri-arrow-up-line align-middle"></i> */}
              </span>
            ) : value < 0 ? (
              <span className="text-danger mb-0">
                {formattedValue}
                {/* <i className="ms-1 ri-arrow-down-line align-middle"></i> */}
              </span>
            ) : (
              <span className="mb-0">{formattedValue}</span>
            )}
          </>
          );
        },
      },
    ]
